import { Pencil, Trash2, BadgeCheck, XCircle } from "lucide-react";

function Criterion({ ok, label }) {
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-bold rounded-full px-2 py-0.5 ${
      ok ? "bg-turq-100 text-turq-900 dark:bg-surface2 dark:text-turq-300" : "bg-beige-600/60 text-mutext dark:bg-surface2"}`}>
      {ok ? <BadgeCheck className="w-3 h-3" /> : <XCircle className="w-3 h-3" />} {label}
    </span>
  );
}

export function CoordinatorsTable({ coords, onEdit, onRemove }) {
  return (
    <div className="bg-surface rounded-2xl shadow-md border border-brd/50 overflow-auto">
      <table className="w-full text-sm min-w-[760px]" data-testid="coordinators-table">
        <thead>
          <tr className="bg-turq-900 text-white">
            <th className="text-right px-4 py-3 font-head text-xs">#</th>
            <th className="text-right px-4 py-3 font-head text-xs">المنسق</th>
            <th className="text-right px-4 py-3 font-head text-xs">المدرسة</th>
            <th className="text-right px-4 py-3 font-head text-xs">مؤشر التمكين</th>
            <th className="text-right px-4 py-3 font-head text-xs">الأداء</th>
            <th className="text-right px-4 py-3 font-head text-xs">معايير الاستحقاق</th>
            <th className="text-right px-4 py-3 font-head text-xs">الشهادات</th>
            <th className="text-right px-4 py-3 font-head text-xs">إجراءات</th>
          </tr>
        </thead>
        <tbody>
          {coords.map((c, i) => (
            <tr key={c.id} data-testid={`coordinator-row-${c.id.slice(0, 8)}`} className="border-b border-brd/50 last:border-0 hover:bg-bg transition-colors">
              <td className="px-4 py-3">
                <span className={`w-6 h-6 rounded-full text-[11px] font-black inline-flex items-center justify-center text-white ${i < 3 ? "bg-coral-600" : "bg-turq-900"}`}>{i + 1}</span>
              </td>
              <td className="px-4 py-3">
                <div className="font-bold">{c.name}</div>
                <div className="text-[10px] text-mutext" dir="ltr">{c.email}{c.phone ? ` · ${c.phone}` : ""}</div>
                <span data-testid={`pledge-chip-${c.id.slice(0, 8)}`}
                  className={`inline-block mt-1 text-[9.5px] font-bold rounded-full px-2 py-0.5 ${c.pledge_accepted ? "bg-turq-100 text-turq-900 dark:bg-surface2 dark:text-turq-300" : "bg-coral-100 text-coral-900 dark:bg-surface2 dark:text-coral-300"}`}>
                  {c.pledge_accepted ? "التعهد موثّق" : "التعهد غير موثّق"}
                </span>
              </td>
              <td className="px-4 py-3 text-[12px]">{c.school_name}</td>
              <td className="px-4 py-3 font-head font-black text-turq-900 dark:text-turq-300">{c.pct ?? 0}%</td>
              <td className="px-4 py-3">
                <div className="flex items-center gap-2">
                  <div className="w-20 h-2 rounded-full bg-surface2 overflow-hidden">
                    <div className="h-full rounded-full bg-coral-600" style={{ width: `${c.performance}%` }} />
                  </div>
                  <span data-testid={`coordinator-performance-${c.id.slice(0, 8)}`} className="text-[11px] font-bold">{c.performance}</span>
                </div>
              </td>
              <td className="px-4 py-3">
                <div className="flex gap-1 flex-wrap">
                  <Criterion ok={c.quality} label="فرصة نوعية" />
                  <Criterion ok={c.regular} label="انتظام" />
                  <Criterion ok={c.engaged} label="تفاعل" />
                </div>
              </td>
              <td className="px-4 py-3 text-center font-bold text-coral-600">{c.certificates_count}</td>
              <td className="px-4 py-3">
                <div className="flex gap-2">
                  <button data-testid={`coordinator-edit-${c.id.slice(0, 8)}`} onClick={() => onEdit(c)}
                    className="w-8 h-8 rounded-lg bg-beige-600 dark:bg-surface2 flex items-center justify-center">
                    <Pencil className="w-3.5 h-3.5 text-turq-900 dark:text-turq-300" />
                  </button>
                  <button data-testid={`coordinator-delete-${c.id.slice(0, 8)}`} onClick={() => onRemove(c)}
                    className="w-8 h-8 rounded-lg bg-coral-100 dark:bg-surface2 flex items-center justify-center">
                    <Trash2 className="w-3.5 h-3.5 text-coral-900 dark:text-coral-300" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
